import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';
import { NoCountrySetKey } from '../../models';

const pathStart = 'System|Criteria|Rules|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Core,
	portal: 'SP',
};

type LocNameStart = 'SPSystemCriteriaRules';
export type SPSystemCriteriaRulesLocNames =
	| `${LocNameStart}NotificationFilterUpdated`
	| `${LocNameStart}ButtonEdit`
	| `${LocNameStart}ButtonUpdate`
	| `${LocNameStart}ButtonCancel`
	| `${LocNameStart}ButtonDelete`
	| `${LocNameStart}LabelDescription`
	| `${LocNameStart}LabelRules`
	| `${LocNameStart}ButtonView`
	| `${LocNameStart}ContentAnd`
	| `${LocNameStart}ContentOr`
	| NoCountrySetKey;

export const spSystemCriteriaRulesLocs: LocDefs<SPSystemCriteriaRulesLocNames> = {
	SPSystemCriteriaRulesNotificationFilterUpdated: {
		defaultValue: 'Changes saved',
		description: 'Criteria rules filter updated notification',
		displayPath: `${pathStart}Changes saved`,
		displayType: 'Notification',
		legacyName: 'Announcements/Tools.AnnouncementCriteria.Notification.FilterChanges',
		...sharedProperties,
	},
	SPSystemCriteriaRulesButtonEdit: {
		defaultValue: 'Edit',
		description: 'Edit button',
		displayPath: `${pathStart}Edit`,
		displayType: 'Button',
		legacyName: 'Announcements/Tools.AnnouncementCriteria.Button.Edit',
		...sharedProperties,
	},
	SPSystemCriteriaRulesButtonUpdate: {
		defaultValue: 'Update',
		description: 'Update button',
		displayPath: `${pathStart}Update`,
		displayType: 'Button',
		legacyName: 'Announcements/Tools.AnnouncementCriteria.Button.UpdateFilter',
		...sharedProperties,
	},
	SPSystemCriteriaRulesButtonCancel: {
		defaultValue: 'Cancel',
		description: 'Cancel button',
		displayPath: `${pathStart}Cancel`,
		displayType: 'Button',
		legacyName: 'Announcements/Tools.AnnouncementCriteria.Button.CancelFilter',
		...sharedProperties,
	},
	SPSystemCriteriaRulesButtonDelete: {
		defaultValue: 'Delete',
		description: 'Delete button',
		displayPath: `${pathStart}Delete`,
		displayType: 'Button',
		legacyName: 'Announcements/Tools.AnnouncementCriteria.Button.Delete',
		...sharedProperties,
	},
	SPSystemCriteriaRulesLabelDescription: {
		defaultValue: 'Description',
		description: 'Label for description field',
		displayPath: `${pathStart}Description`,
		displayType: 'Label',
		legacyName: 'Announcements/Tools.AnnouncementCriteria.FieldLabel.Description',
		...sharedProperties,
	},
	SPSystemCriteriaRulesLabelRules: {
		defaultValue: 'Rules',
		description: 'Label for rules field',
		displayPath: `${pathStart}Rules`,
		displayType: 'Label',
		legacyName: 'Announcements/Tools.AnnouncementCriteria.FieldLabel.Rule',
		...sharedProperties,
	},
	SPSystemCriteriaRulesButtonView: {
		defaultValue: 'View',
		description: 'Button to view criteria rule items',
		displayPath: `${pathStart}View`,
		displayType: 'Button',
		legacyName: 'Announcements/Tools.AnnouncementCriteria.Button.ViewRule',
		...sharedProperties,
	},
	SPSystemCriteriaRulesContentAnd: {
		defaultValue: 'and',
		description: 'Text shown for "and" in criteria rules',
		displayPath: `${pathStart}And`,
		displayType: 'Content',
		legacyName: 'Announcements/Tools.AnnouncementCriteria.MenuItem.And',
		...sharedProperties,
	},
	SPSystemCriteriaRulesContentOr: {
		defaultValue: 'or',
		description: 'Text shown for "or" in criteria rules',
		displayPath: `${pathStart}Or`,
		displayType: 'Content',
		legacyName: 'Announcements/Tools.AnnouncementCriteria.MenuItem.Or',
		...sharedProperties,
	},
	SPSystemCriteriaRulesContentNoCountrySet: {
		defaultValue: 'No country set',
		description: 'Text shown when no country is set',
		displayPath: `${pathStart}No country set`,
		displayType: 'Content',
		legacyName: 'Announcements/Tools.AnnouncementCriteria.Content.NoCountrySet',
		...sharedProperties,
	},
};

export type SPSystemCriteriaRulesLocType = LocMap<SPSystemCriteriaRulesLocNames>;
